import cookiesProvider from "../providers/cookies-provider";
import {useCallback, useState} from "react";
import axios from "axios";
import {getApiUrl} from "../utils/urls";
const url = getApiUrl();

export function useBaseRequest() {
  const token = cookiesProvider.getToken();
  const [isLoading, setIsLoading] = useState(false);

  const request = useCallback(({ path, method, body, headers, query }) => {
    setIsLoading(true);
    return axios.request({
      method,
      url: `${url}/${path}`,
      headers: { ...headers, Authorization: `Bearer ${token}` },
      data: body,
      params: query,
    }).finally(() => setIsLoading(false));
  }, [token])

  const post = useCallback(({ path , body, headers, query }) => {
    return request({
      path,
      body,
      headers,
      query,
      method: 'POST'
    })
  }, [request])

  const get = useCallback(({ path , body, headers, query }) => {
    return request({
      path,
      body,
      headers,
      query,
      method: 'GET'
    })
  }, [request])

  const put = useCallback(({ path , body, headers, query }) => {
    return request({
      path,
      body,
      headers,
      query,
      method: 'PUT'
    })
  }, [request])

  const remove = useCallback(({ path , body, headers, query }) => {
    return request({
      path,
      body,
      headers,
      query,
      method: 'DELETE'
    })
  }, [request])


  return {
    request,
    put,
    get,
    remove,
    post,
    isLoading
  }
}